import React, { useState, useEffect, useRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import { extendedAlphaNumericRegex, digitRegex, alphabetRegex } from '../utils/regexPatterns';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './OwnerRegistration.css';
import FadeLoader from "react-spinners/FadeLoader";
import { entityRegistration, checkEmailExistence, fetchUserDetailsByEmailId, UpdateProfileByEntity, OwnerRegistrationB2C, UpdateOwnerVideoUrl } from '../../Services/userService.js'
import termsOfServicesData from '../TermsOfServices/TermsOfServices.json';
import termsOfUsesData from '../TermsOfServices/TermsOfUses.json'
import BootstrapDialog from '../BootstrapDialog/BootstrapDialog.jsx';
import BootstrapDialogpopup from './EmailConfirmationPopUpModel.jsx'
import { FcCheckmark } from "react-icons/fc";
import { digitsWithAlphabetsRegex } from '../utils/regexPatterns'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ValidationMessages from "../utils/validationMessages";
import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook
import { BlobServiceClient, BlobClient } from '@azure/storage-blob';
import UploadOwnerRecording from './UploadOwnerRecording.jsx';



const OwnerRegistration = (props) => {
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const sasToken = process.env.REACT_APP_BLOB_SAS_TOKEN;
    const sasURL = process.env.REACT_APP_BLOB_SAS_URL;
    const folder = process.env.REACT_APP_UPLOAD_FOLDER || 'uploadpdf';

    const videoSasToken = process.env.REACT_APP_BLOB_SAS_TOKEN_VIDEO;
    const videoSasURL = process.env.REACT_APP_BLOB_SAS_URL_VIDEO;
    const videoFolderName = process.env.REACT_APP_VIDEO_UPLOAD_FOLDER || 'terms-recordings';
    const resetUrl = `${window.location.origin}/PasswordSetupPage`;

    const [loader, setLoader] = useState(false);
    const [dialogData, setDialogData] = useState({ title: '', sections: [] });
    const [open, setOpen] = useState(false);
    const [openpopup, setOpenmodel] = useState(false);
    const [EmailPopUp, setEmailPopUp] = useState(false);
    const [isemailVerified, setEmailverified] = useState(false);
    const [isphoneVerified, setPhoneVerified] = useState(false);
    const [, setPhoneVerification] = useState(false);
    const [InValidOTP, setInValidOTP] = useState("");
    const [cityval] = useState();
    const [OTPValidation, setOTPValidation] = useState("");
    const [, setDisabledStateCity] = useState(false);
    const navigate = useNavigate();
    const [todayDate, setTodayDay] = useState(() => new Date());
    const fileInputRef = useRef(null);
    const [reitId, setReitId] = useState(null);
    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [selectedOwnerForVideo, setSelectedOwnerForVideo] = useState(null);
    const [uploadedVideoFileSize, setUploadedVideoFileSize] = useState(null);
    const { empDetails } = useUser();
    const [formData, setFormData] = useState({
        EntityName: '',
        EnityMailingAdderess: '',
        EnityMailingAdderess2: '',
        Country: 'United States',
        CityId: '',
        Zipcode: '',
        StateId: '',
        FirstName: '',
        LastName: '',
        Title: 'Admin',
        EmailId: '',
        MobileNumber: '',
        OfficeNumber: '',
        Password: 'Geoparking@123',
        TandC: false,
        ConfirmPassword: 'Geoparking@123',
        IsEmailPhoneVerified: false,
        IsEmailVerified: false,
        IsPhoneVerified: false,
        TandC1: false,
        TandC1CreatedDate: '',
        TandC2: false,
        TandC2CreatedDate: '',
        IsTempPassword: false,
        IsReitOwner: false,
        IsReitOwnerCreatedDate: '',
        EmpFirstName: empDetails?.firstName || '',
        EmpLastName: empDetails?.lastName || '',
        AgreementFileURL: '',
        AgreementFileName: '',
        UploadRecordedVideoURL: '',
        UploadedVideoFileName: '',
    });
    const initialFormDataRef = useRef({});
    const [originalEmail, setOriginalEmail] = useState("");

    useEffect(() => {
        if (Object.keys(initialFormDataRef.current).length === 0) {
            initialFormDataRef.current = { ...formData };
        }
    }, []);

    useEffect(() => {
        if (!initialFormDataRef.current || Object.keys(initialFormDataRef.current).length === 0) {
            props.setOwnerRegistrationChanges(false);
            return;
        }

        const excludedKeys = [
            "Country",
            "Password",
            "ConfirmPassword",
            "EmpFirstName",
            "EmpLastName"
        ];

        const hasChanges = Object.entries(formData).some(([key, value]) => {
            if (excludedKeys.includes(key)) return false;
            const initialValue = initialFormDataRef.current[key];
            const normValue = value === undefined ? '' : value;
            const normInitial = initialValue === undefined ? '' : initialValue;
            return normValue !== normInitial;
        });
        props.setOwnerRegistrationChanges(hasChanges);
    }, [formData]);

    useEffect(() => {
        const run = async () => {
            if (formData?.UploadRecordedVideoURL) {
                const size = await getVideoSize(formData.UploadRecordedVideoURL); // full SAS URL
                if (size != null) setUploadedVideoFileSize(size);
            } else {
                setUploadedVideoFileSize(null);
            }
        };
        run();
    }, [formData?.UploadRecordedVideoURL]);

    const getVideoSize = async (blobSasUrl) => {
        try {
            const blobClient = new BlobClient(blobSasUrl);  // <-- IMPORTANT
            const props = await blobClient.getProperties(); // HEAD under the hood, correctly signed
            return props.contentLength;                     // bytes
        } catch (err) {
            console.error("Error fetching blob size:", err);
            return null;
        }
    };


    const [errors, setErrors] = useState({});
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const wrapperRef = useRef(null);
    const [, setShowPopup] = useState(false);
    const extendedCities = cities.some((city) => city.iso2 === (formData.CityId || cityval))
        ? cities
        : [...cities, { id: "custom", iso2: formData.CityId || cityval, name: formData.CityId || cityval }];

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            alert("Please select a file.");
            return;
        }


        const url = new URL(sasURL);
        const containerName = url.pathname.split('/')[1]; // "reitpdffiles"
        const storageAccount = url.hostname.split('.')[0]; // "stltstaging"

        const blobServiceClient = new BlobServiceClient(
            `https://${storageAccount}.blob.core.windows.net/?${sasToken}`
        );
        const containerClient = blobServiceClient.getContainerClient(containerName);
        const blockBlobClient = containerClient.getBlockBlobClient(`${folder}/${file.name}`);
        try {
            const uploadResponse = await blockBlobClient.uploadData(file, {
                blobHTTPHeaders: { blobContentType: file.type }
            });
            const fileUrl = `https://${storageAccount}.blob.core.windows.net/${containerName}/${folder}/${encodeURIComponent(file.name)}?${sasToken}`;

            setErrors(prev => ({ ...prev, pdfUpload: "" }));
            setFormData(pre => ({
                ...pre,
                AgreementFileName: file.name,
                AgreementFileURL: fileUrl
            }))

            console.log("Upload success:", uploadResponse.requestId);
        } catch (err) {
            console.error("Upload error:", err);
        }
    };




    const triggerFileUpload = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    useEffect(() => {
        const fetchStates = async () => {
            try {
                 const response = await axios.get(`${hostPath}/api/GetUSStates`, {
                });
                const sortedStates = response.data
                    .filter(state => extendedAlphaNumericRegex.test(state.iso2))
                    .sort((a, b) => a.name.localeCompare(b.name));
                setStates(sortedStates);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchStates();
    }, []);
    useEffect(() => {
        const fetchcityid = async (id) => {
            try {
            } catch (error) {
                console.error("Error fetching cities:", error);
            }
        };

        if (formData.StateId) {  // Ensure both FormData.StateId and data are available
            const stateid = findIso2Code(formData.StateId, states);
            if (stateid) {
                fetchcityid(stateid);
            } else {
                console.warn("State not found");
            }
        }
    }, [formData.StateId]);

    function findIso2Code(stateName, data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name.toLowerCase() === stateName.toLowerCase()) {
                return data[i].iso2;
            }
        }
        return null;  // Return null if not found
    }

    // Fetch cities based on state selection
    const fetchCities = async (stateId) => {
        try {
            const response = await axios.post(`${hostPath}/api/GetCitiesByState`, {stateId:stateId});
            setCities(response.data);  // Update cities
            return response.data;
        } catch (error) {
            console.error("Error fetching cities:", error);
            return [];
        }
    };

    useEffect(() => {
        const fetchOwnerdetails = async () => {
            setLoader(true);  // Show loader before fetching data

            try {
                const ownerDetails = await fetchUserDetailsByEmailId(props.EmailIdOwner);
                setOriginalEmail(props.EmailIdOwner);

                const newFormData = {
                    EntityName: ownerDetails?.entityName || "",
                    EnityMailingAdderess: ownerDetails?.enityMailingAdderess || "",
                    EnityMailingAdderess2: ownerDetails?.enityMailingAdderess2 || "",
                    Country: ownerDetails?.country || "United States",
                    Zipcode: ownerDetails?.zipcode || "",
                    StateId: ownerDetails?.stateId || "",
                    EmailId: ownerDetails?.emailId || "",
                    FirstName: ownerDetails?.firstName || "",
                    LastName: ownerDetails?.lastName || "",
                    MobileNumber: ownerDetails?.mobileNumber || "",
                    OfficeNumber: ownerDetails?.officeNumber || "",
                    Title: ownerDetails?.title || "",
                    CityId: ownerDetails?.cityId || "",
                    IsEmailPhoneVerified: ownerDetails?.isEmailPhoneVerified || false,
                    IsEmailVerified: ownerDetails?.isEmailVerified || false,
                    IsPhoneVerified: ownerDetails?.isPhoneVerified || false,
                    TandC1: ownerDetails?.tandC ? ownerDetails?.tandC : ownerDetails?.tandC1 || false,
                    TandC2: ownerDetails?.tandC ? ownerDetails?.tandC : ownerDetails?.tandC2 || false, IsTempPassword: ownerDetails?.isTempPassword || false,
                    IsReitOwner: ownerDetails?.isReitOwner || false,
                    TandC1CreatedDate:
                        (ownerDetails?.tandC ? ownerDetails?.tandC : ownerDetails?.tandC1)
                            ? (
                                ownerDetails.tandC1CreatedDate !== undefined &&
                                    ownerDetails.tandC1CreatedDate !== null &&
                                    ownerDetails.tandC1CreatedDate.trim?.() !== ""
                                    ? ownerDetails.tandC1CreatedDate
                                    : ownerDetails?.createdDate ||
                                    new Date().toLocaleString("en-US", {
                                        month: "numeric",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        second: "numeric",
                                        hour12: true,
                                    }).replace(",", "")
                            )
                            : "",

                    TandC2CreatedDate:
                        (ownerDetails?.tandC ? ownerDetails?.tandC : ownerDetails?.tandC2)
                            ? (
                                ownerDetails.tandC2CreatedDate !== undefined &&
                                    ownerDetails.tandC2CreatedDate !== null &&
                                    ownerDetails.tandC2CreatedDate.trim?.() !== ""
                                    ? ownerDetails.tandC2CreatedDate
                                    : ownerDetails?.createdDate ||
                                    new Date().toLocaleString("en-US", {
                                        month: "numeric",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        second: "numeric",
                                        hour12: true,
                                    }).replace(",", "")
                            )
                            : "",

                    IsReitOwnerCreatedDate:
                        ownerDetails?.isReitOwner
                            ? (
                                ownerDetails.isReitOwnerCreatedDate !== undefined &&
                                    ownerDetails.isReitOwnerCreatedDate !== null &&
                                    ownerDetails.isReitOwnerCreatedDate.trim?.() !== ""
                                    ? ownerDetails.isReitOwnerCreatedDate
                                    : ownerDetails?.createdDate ||
                                    new Date().toLocaleString("en-US", {
                                        month: "numeric",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        second: "numeric",
                                        hour12: true,
                                    }).replace(",", "")
                            )
                            : "", EmpFirstName: ownerDetails?.empFirstName ? ownerDetails?.empFirstName : empDetails?.firstName || "",
                    EmpLastName: ownerDetails?.empLastName ? ownerDetails?.empLastName : empDetails?.lastName || "",
                    AgreementFileName: ownerDetails?.agreementFileName || '',
                    AgreementFileURL: ownerDetails?.agreementFileURL || '',
                    UploadRecordedVideoURL: ownerDetails?.videoUrl || '',
                    UploadedVideoFileName: ownerDetails?.videoFileName || ''
                };
                setReitId(ownerDetails?.reitId);
                setFormData(newFormData);
                initialFormDataRef.current = newFormData;
                // setTodayDay(dateValue);
                setPhoneVerified(ownerDetails?.isEmailPhoneVerified ? ownerDetails?.isEmailPhoneVerified : ownerDetails?.isPhoneVerified);
                setEmailverified(ownerDetails?.isEmailPhoneVerified ? ownerDetails?.isEmailPhoneVerified : ownerDetails?.isEmailVerified);

            } catch (error) {
                console.error("Error fetching owner details:", error);
                setTodayDay(new Date());
            } finally {
                setLoader(false);
            }
        };

        if (props.EmailIdOwner) {
            fetchOwnerdetails();
        }
    }, [props.EmailIdOwner]);


    const handleCloseVideoModal = () => {
        setVideoModalOpen(false);
        setSelectedOwnerForVideo(null);
    };
    const handleSaveVideo = async (file) => {
        setLoader(true);
        if (!file) return;

        if (!videoSasURL || typeof videoSasURL !== 'string' || !videoSasURL.startsWith('http')) {
            console.error("Azure SAS URL is missing or invalid:", videoSasURL);
            return;
        }
        if (!videoSasToken) {
            console.error("Azure SAS token is missing or invalid.");
            return;
        }

        try {
            const url = new URL(videoSasURL);
            const containerName = url.pathname.split('/')[1];
            const storageAccountName = url.hostname.split('.')[0];

            const blobServiceClient = new BlobServiceClient(`https://${storageAccountName}.blob.core.windows.net/?${videoSasToken}`);
            const containerClient = blobServiceClient.getContainerClient(containerName);
            const blockBlobClient = containerClient.getBlockBlobClient(`${videoFolderName}/${file.name}`);

            await blockBlobClient.uploadData(file, {
                blobHTTPHeaders: { blobContentType: file.type }
            });

            const videoUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${videoFolderName}/${encodeURIComponent(file.name)}?${videoSasToken}`;

            console.log("Video uploaded successfully. URL:", videoUrl);
            // setRecordedVideoUrl(videoUrl);

            // 1. Update video URL in backend for the selected user
            console.log("Selected owner for video update:", selectedOwnerForVideo);
            console.log("Selected owner for video update:", selectedOwnerForVideo?.EmailId);

            if (selectedOwnerForVideo?.EmailId) {
                console.log("enter into thte if part inas update url");

                await UpdateOwnerVideoUrl(selectedOwnerForVideo.EmailId, videoUrl, file.name);
            }

            setFormData(prev => ({
                ...prev,
                UploadRecordedVideoURL: videoUrl,
                UploadedVideoFileName: file.name
            }));
            setVideoModalOpen(false);
            setSelectedOwnerForVideo(null);
        } catch (error) {
            console.error("Error uploading video:", error);
        }
        finally {
            setLoader(false);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (name === "EntityName" && value.trim()) {
                if (/^\d+$/.test(value)) {
                    newErrors.EntityName = ValidationMessages.entitydigits;
                }
                else if (/^&+$/.test(value)) {
                    newErrors.EntityName = ValidationMessages.entitycon;
                }
                else if (/^\.+$/.test(value)) {
                    newErrors.EntityName = ValidationMessages.entitydots;
                }
                 else if (!/(?=.*[a-zA-Z])^[a-zA-Z0-9\s'".,;:?[\]{}|@!<>#$%^&*~`“”]+$/u.test(value)) {
                    newErrors.EntityName = ValidationMessages.entityletteranddigitd;
                }
                else {
                    delete newErrors.EntityName;
                }
            }
            if (name === "EmailId" && ((/\S+@\S+\.\S+/.test(value)) || value === "")) {
                delete newErrors.EmailId;
                setEmailverified(false);
            }

            if (name === "StateId" && value) {
                delete newErrors.StateId;
            }
            if (name === "CityId" && value) {
                delete newErrors.CityId;
            }
            if (name === "MobileNumber") {
                setPhoneVerified(false);
                delete newErrors.MobileNumber;
            }
            if (["FirstName", "LastName"].includes(name) && alphabetRegex.test(value)) {
                delete newErrors[name];
            } if (name === "Title") {
                delete newErrors.Title
            }
            if (name === "Zipcode" && digitRegex.test(value) && value.length === 5) {
                delete newErrors.Zipcode;
            }
            return newErrors;
        });
    };

    const handleSearchChange = async (e) => {
        const { value } = e.target;
        setFormData((prev) => ({ ...prev, EnityMailingAdderess: value }));
        if (value.trim().length > 2) {
            try {
                const response = await axios.get(
                    `https://atlas.microsoft.com/search/address/json?&subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&language=en-US&query=${value}&countrySet=US`
                );
                const results = response.data.results || [];
                const addressSuggestions = results?.filter(result => result.address.countryCode === 'US' && result.address.streetNumber).map((result) => result.address);
                setSuggestions(addressSuggestions);
                setShowSuggestions(true);
            } catch (error) {
                console.error("Error fetching address suggestions:", error);
            }
        } else {
            setFormData((prevState) => ({
                ...prevState,
                CityId: "",
                StateId: "",
                Zipcode: "",

            }));
            setDisabledStateCity(false);
            setShowSuggestions(false); // Hide suggestions if input length <= 2
        }
    };

    const handleAddressValidation = async (value) => {
        try {
            const response = await axios.get(
                `https://atlas.microsoft.com/search/address/json?&subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&language=en-US&query=${value}&countrySet=US`
            );
            const results = response.data.results || [];
            const exactMatch = results.find(
                (result) => result.address.countryCode === 'US' &&
                    result.address.freeformAddress === value.trim()
            );
            if (exactMatch) {
                return true;
            } else {
                return false;

            }

        } catch (error) {
            console.error("Error fetching address suggestions:", error);
        }
    };


    // Handle address selection from suggestions
    const handleAddressSelect = async (address) => {
        try {
            // Find the selected state from the list of states
            const selectedState = states.find(
                (state) => state.name.toLowerCase() === address.countrySubdivisionName?.toLowerCase()
            );
            if (selectedState) {
                // Fetch cities for the selected state and then find the city
                const cityList = await fetchCities(selectedState.iso2);

                const selectedCity = cityList.find(
                    (city) => city.name.toLowerCase() === address.municipality?.toLowerCase()
                );
                setFormData((prevState) => ({
                    ...prevState,
                    CityId: selectedCity ? selectedCity.name : address?.municipality || "",
                    StateId: selectedState?.name,
                    Zipcode: address.postalCode,
                    EnityMailingAdderess: address.freeformAddress
                }));
                setShowSuggestions(false);
                setDisabledStateCity(true)

                // Clear validation errors for CityId, StateId, Zipcode, and EnityMailingAdderess
                setErrors((prevErrors) => {
                    const newErrors = { ...prevErrors };

                    // Clear the errors if valid data is set
                    if (selectedCity) delete newErrors.CityId;
                    if (selectedState) delete newErrors.StateId;
                    if (address.postalCode) delete newErrors.Zipcode;
                    if (address.freeformAddress) delete newErrors.EnityMailingAdderess;

                    return newErrors;
                });
            } else {
                console.warn("No matching state found for the address:", address.countrySubdivisionName);
            }
        } catch (error) {
            console.error("Error in handleAddressSelect:", error);
        } finally {
            // setSuggestions([]);
            setShowSuggestions(false);
        }
    };


    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowSuggestions(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const isEmailChanged = () => {
  return (
    originalEmail &&
    formData.EmailId &&
    originalEmail.toLowerCase() !== formData.EmailId.toLowerCase()
  );
};

    const validateEmailandphone = async (emailid, phonenumber) => {
        const newErrors = {};
        const { EmailId, MobileNumber } = formData;
        if (phonenumber) {
            if (!MobileNumber) {
                newErrors.MobileNumber = ValidationMessages.phoneRequired;
            } else {
                const phoneNumber = MobileNumber.replace(/\D/g, "");
                if (phoneNumber.length !== 11 || !phoneNumber.startsWith("1")) {
                    newErrors.MobileNumber = ValidationMessages.inValidPhone;
                }
            }
        } else if (emailid) {
            const emailExists = await checkEmailExistence(formData.EmailId);
            if (!EmailId || !/\S+@\S+\.\S+/.test(EmailId)) {
                newErrors.EmailId = ValidationMessages.validEmail;
            }
            else if (emailExists && !props?.EmailIdOwner) {
                newErrors.EmailId = ValidationMessages.emailAlredyExist;
            }
            else if (emailExists && props?.EmailIdOwner && isEmailChanged()) {
                newErrors.EmailId = ValidationMessages.emailAlredyExist;
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }
    const validateForm = async (sec1, sec2, sec3) => {
        const newErrors = {};
        const { EntityName, FirstName, LastName, EnityMailingAdderess, Title, EmailId, Zipcode, CityId, StateId, MobileNumber, OfficeNumber, TandC2, TandC1, IsReitOwner, AgreementFileName, AgreementFileURL } = formData;
        if (sec1) {
            if (!MobileNumber) {
                newErrors.MobileNumber = ValidationMessages.phoneRequired;
            } else {
                const phoneNumber = MobileNumber.replace(/\D/g, "");
                if (phoneNumber.length !== 11 || !phoneNumber.startsWith("1")) {
                    newErrors.MobileNumber = ValidationMessages.inValidPhone;
                }
            }
            if (!OfficeNumber) {
                // errors.OfficeNumber = "Mobile Number is required";
            } else {
                const officeNumber = formData.OfficeNumber.replace(/\D/g, "");
                if (officeNumber.length !== 11 || !officeNumber.startsWith("1")) {
                    newErrors.OfficeNumber = ValidationMessages.OfficePhone;
                }
            }
            if (!FirstName || !alphabetRegex.test(FirstName)) newErrors.FirstName = ValidationMessages.firstnameAndAlphabets;
            if (!LastName || !alphabetRegex.test(LastName)) newErrors.LastName = ValidationMessages.lastnameAndAlphabets;
            if (!Title) newErrors.Title = ValidationMessages.titleAndAlphabets;
            const emailExists = await checkEmailExistence(formData.EmailId);
            if (!EmailId || !/\S+@\S+\.\S+/.test(EmailId)) {
                newErrors.EmailId = ValidationMessages.validEmail;
            }
            else if (emailExists && !props?.EmailIdOwner && !isemailVerified) {
                newErrors.EmailId = ValidationMessages.emailAlredyExist;
            }
              else if (emailExists && !props?.EmailIdOwner) {
                newErrors.EmailId = ValidationMessages.emailAlredyExist;
            }
            else if (emailExists && props?.EmailIdOwner && isEmailChanged()) {
                                newErrors.EmailId = ValidationMessages.emailAlredyExist;}

        }
        if (sec2) {
            if (!digitsWithAlphabetsRegex.test(EntityName)) newErrors.EntityName = ValidationMessages.entitydigits;
            if (!EntityName) newErrors.EntityName = ValidationMessages.entityName;
            if (!EnityMailingAdderess) newErrors.EnityMailingAdderess = ValidationMessages.entitymailrequired;
            const isaddressvalid = await handleAddressValidation(EnityMailingAdderess);
            if (!isaddressvalid) {
                newErrors.EnityMailingAdderess = ValidationMessages.entitymailingadd;
            }
            if (!Zipcode || !digitRegex.test(Zipcode) || Zipcode.length !== 5) newErrors.Zipcode = ValidationMessages.validZip;
            if (!StateId) newErrors.StateId = ValidationMessages.statereq;
            if (!CityId) newErrors.CityId = ValidationMessages.cityReq;
        }
        if (sec3) {
            // Case 1: None of the 3 checkboxes are checked
            if (!TandC1 && !TandC2 && !IsReitOwner) {
                newErrors.TandC2 = ValidationMessages.termsservice;
                newErrors.TandC1 = ValidationMessages.termsuse;
                newErrors.IsReitOwner = ValidationMessages.termsservice;
            } else {
                // Case 2: If IsReitOwner is selected, skip T&C checks
                if (IsReitOwner) {
                    // Only check PDF upload if IsReitOwner is selected
                    if (formData.IsReitOwner && (!AgreementFileName || !AgreementFileURL)) {
                        newErrors.pdfUpload = ValidationMessages.uploadFileReq;
                    }
                } else {
                    // Check each T&C box individually
                    if (!TandC2) newErrors.TandC2 = ValidationMessages.termsservice;
                    if (!TandC1) newErrors.TandC1 = ValidationMessages.termsuse;
                }
            }
            // Email and phone verification checks (always run)
            if (!isphoneVerified) {
                newErrors.MobileNumber = ValidationMessages.mobileVerify;
            }
            if (!isemailVerified) {
                newErrors.EmailId = ValidationMessages.emailVerify;
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmitEmail = async (e) => {
        e.preventDefault();
        try {
            const isValid = await validateEmailandphone(true, false);
            if (isValid) {
                setLoader(true);
                await sendOTPByEmail();
            }
        } catch (error) {
            console.error('Error during form submission:', error);
        } finally {
            // Set loader to false after sendOTPByEmail completes (or an error occurs)
            setLoader(false);
        }
    };
    const handleSubmitPhone = async (e) => {
        e.preventDefault();
        try {
            const isValid = await validateEmailandphone(false, true);
            if (isValid) {
                setLoader(true);  // Set loader to true before making any request  


                // Wait for the response from sendOTPByEmail before proceeding
                await sendOTPByPhone(formData?.MobileNumber);
            }
        } catch (error) {
            console.error('Error during form submission:', error);
        } finally {
            // Set loader to false after sendOTPByEmail completes (or an error occurs)
            setLoader(false);
        }
    };

    const handleCheckboxChange1 = (e) => {
        const isChecked = e.target.checked;
        setFormData((prev) => ({
            ...prev,
            TandC1: isChecked,
            TandC1CreatedDate: isChecked
                ? new Date().toLocaleString('en-US', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true
                }).replace(',', '')
                : '',
            AgreementFileURL: '',
            AgreementFileName: '',
            // If checking TandC1 and REIT is checked, uncheck REIT
            IsReitOwner: isChecked && prev.IsReitOwner ? false : prev.IsReitOwner,
        }));
        errors.TandC1 = "";
        errors.IsReitOwner = "";
    };
    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setFormData((prev) => ({
            ...prev,
            TandC2: isChecked,
            TandC2CreatedDate: isChecked
                ? new Date().toLocaleString('en-US', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true
                }).replace(',', '')
                : '',
            AgreementFileURL: '',
            AgreementFileName: '',
            // If checking TandC2 and REIT is checked, uncheck REIT
            IsReitOwner: isChecked && prev.IsReitOwner ? false : prev.IsReitOwner,
        }));
        errors.TandC2 = "";
        errors.IsReitOwner = "";
    };
    const handleCheckboxChange3 = (e) => {
        const isChecked = e.target.checked;
        setFormData((prev) => ({
            ...prev,
            IsReitOwner: isChecked,
            IsReitOwnerCreatedDate: isChecked
                ? new Date().toLocaleString('en-US', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: true
                }).replace(',', '')
                : '',
            TandC2CreatedDate: '',
            TandC1CreatedDate: '',
            // If REIT is checked, uncheck TandC1 and TandC2
            TandC1: isChecked ? false : prev.TandC1,
            TandC2: isChecked ? false : prev.TandC2,
        }));
        errors.IsReitOwner = "";
        errors.TandC2 = "";
        errors.TandC1 = "";
    };

    const handleClickOpen = (type) => () => {
        let item;
        if (type === 'termsOfServices') {
            item = termsOfServicesData.termsOfServices[0];
        } else if (type === 'termsOfUses') {
            item = termsOfUsesData.termsOfUses[0];
        }
        if (item) {
            setDialogData(item);
            setOpen(true);
        } else {
            console.error("No data found.");
        }
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleCancel = () => {
        props.handleRegsiterOwner(false);
        props.setOwnerRegistrationChanges(false);
        setErrors({});
    };


    const sendOTPByEmail = async () => {
        let EmailId = {
            EmailId: formData.EmailId
        };
        setLoader(true);
        try {
            const requestOptions = {
                method: "POST",
                headers: {
                    "x-functions-key": hostHeader,
                },
                body: JSON.stringify(EmailId),
            };
            const response = await axios.post(
                `${hostPath}/api/SendOtpToEmail`,
                requestOptions.body,
                { headers: requestOptions.headers }
            );
            if (response?.data) {
                setLoader(false);
                setEmailPopUp(true)
                setOpenmodel(true)
                setInValidOTP("")
                setOTPValidation("")
            }
        } catch (error) {
            console.error("Error sending email:", error);
        }
        finally {
            setLoader(false);
        }
    };
    const sendOTPByPhone = async (MobileNumber) => {
        setLoader(true);
        try {
            const response = await axios.post(
                `${hostPath}/api/SendOtpToSMS`,
                { CellNumber: MobileNumber },
                {
                    headers: {
                        "x-functions-key": hostHeader,
                    }
                }
            );
            if (response.data) {
                setPhoneVerification(true);
                setEmailPopUp(false);
                setOpenmodel(true);
                setInValidOTP("");
                setOTPValidation("");
            }
        } catch (error) {
            console.error("Error sending SMS:", error);
        } finally {
            setLoader(false);
        }
    };


    const handleVerify = async (otp, type) => {
        if (otp.length !== 5) {
            setOTPValidation(ValidationMessages.fivedigitOTP)
        } else {
            setOTPValidation("")
            const OTP = Number(otp)
            if (EmailPopUp) {
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "x-functions-key": hostHeader,
                    },
                    body: JSON.stringify({
                        EmailId: formData.EmailId,
                        OTP: OTP,
                    }),
                };

                const response = await axios.post(
                    `${hostPath}/api/VerifyOtp`,
                    requestOptions.body,
                    { headers: requestOptions.headers }
                );
                if (response.data.status === true) {
                    setInValidOTP("")
                    setEmailverified(true);
                    setOpenmodel(false);
                }
                else if (response.data.status === false) {
                    setInValidOTP(response.data.responseMessage)
                }
            } else {
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "x-functions-key": hostHeader,
                    },
                    body: JSON.stringify({
                        CellNumber: formData.MobileNumber,
                        OTP: OTP,
                    }),
                };
                const response = await axios.post(
                    `${hostPath}/api/VerifySMSOtp`,
                    requestOptions.body,
                    { headers: requestOptions.headers }
                );
                //If OTP is verified successfully, redirect the user to the account info page
                if (response.data && response.data.status === true) {
                    setPhoneVerified(true);
                    setInValidOTP("")
                    setOpenmodel(false)
                }
                else if (response.data.status === false) {
                    setInValidOTP(response.data.responseMessage)
                }
            }
        }
    };
    const handleRegistrationSave = async () => {
        try {
            setLoader(true);
            const isValid = await validateForm(true, true, formData?.IsReitOwner || formData?.TandC1 || formData?.TandC2 || props.ownerb2cId);
            if (isValid) {
                let updatedFormData = { ...formData, EmpId: props.empId, IsEmailVerified: isemailVerified, IsPhoneVerified: isphoneVerified };
                let entityRegistrationResponse;
                if (props.EmailIdOwner) {
                    updatedFormData = { ...formData, EmpId: props.empId, EntityRegistrationID: props.entityIdOwner, IsEmailVerified: isemailVerified, IsPhoneVerified: isphoneVerified, UserId: props.ownerb2cId };
                    entityRegistrationResponse = await UpdateProfileByEntity(updatedFormData);
                }
                else {
                    entityRegistrationResponse = await entityRegistration(updatedFormData);
                }
                if (entityRegistrationResponse) {
                    if (entityRegistrationResponse.status = true) {
                        const entityRegistrationID = entityRegistrationResponse?.userData?.entityRegistrationID;
                        setFormData((prev) => ({ ...prev, EnityMailingAdderess: entityRegistrationResponse?.userData?.enityMailingAdderess }));
                        toast.success(entityRegistrationResponse.responseMessage);
                        setTimeout(() => {
                            navigate(`/OwnerRegistrationDashboard/${formData.FirstName}`, {
                                state: { ownerId: entityRegistrationID }
                            });
                            props.handleRegsiterOwner(false);
                        }, 1000);

                    } else {
                        toast.error(entityRegistrationResponse.responseMessage)
                    }

                }
            } else {
                setShowPopup(true);
            };
            //   }
        } catch (error) {
            console.error("Error in registration", error);
        } finally {
            setLoader(false);
        }
    };
    const handleRegistration = async () => {
        try {
            setLoader(true);
            const isValid = await validateForm(true, true, true);
            if (!isValid) return;
            let updatedFormData = {
                ...formData,
                EmpId: props.empId,
                IsEmailVerified: isemailVerified,
                IsPhoneVerified: isphoneVerified,
                IsTempPassword: true
            };
            if (props.EmailIdOwner) {
                updatedFormData.EntityRegistrationID = props.entityIdOwner;
            }
            const userdata = {
                userDetails: updatedFormData,
                metadata: { loginLink: resetUrl }
            };
            const b2cresponse = await OwnerRegistrationB2C(userdata);
            if (b2cresponse.status) {
                toast.success(b2cresponse.message);
                setTimeout(() => {
                    const entityRegistrationId = b2cresponse?.entityId;
                    navigate(`/OwnerRegistrationDashboard/${formData.FirstName}`, {
                        state: { ownerId: entityRegistrationId }
                    })
                    props.handleRegsiterOwner(false);
                }, 1000);
            }
            //need to add toast messsage 
        } catch (error) {
            console.error("Error in registration", error);
        } finally {
            setLoader(false);
        }
    };



    const handleResend = (type) => {
        // Logic to resend the OTP
    };
    const onClose = () => {
        setOpenmodel(false)
        setInValidOTP("")
        setOTPValidation("")

    }

    return (
        <div>
            {loader && (
                <div className="loader-overlay" style={{ zIndex: 1000 }}>
                    <FadeLoader />
                </div>
            )}
            <ToastContainer />
            {props.registerOwner && (
                <div className="OwnerRegistration-Container">
                    <h4>Owner Registration</h4>
                    <form >
                        <div className="section">
                            <h5>Personal Information</h5>
                            <div className="d-flex">
                                <InputField label="First Name" name="FirstName" value={formData.FirstName} onChange={handleInputChange} error={errors.FirstName} required />
                                <InputField label="Last Name" name="LastName" value={formData.LastName} onChange={handleInputChange} error={errors.LastName} required />
                                <InputField label="Title" name="Title" value={formData.Title} error={errors.Title} required disabled={true} />
                                <div style={{ position: 'relative' }}>
                                    <InputField
                                        label="Email Address"
                                        name="EmailId"
                                        type="email"
                                        value={formData.EmailId}
                                        onChange={handleInputChange}
                                        error={errors.EmailId}
                                        required
                                        style={{
                                            width: `${Math.max(200, formData.EmailId.length * 10)}px`,
                                            paddingRight: '80px',
                                            transition: 'width 0.2s ease-in-out',
                                        }}
                                    />
                                    {isemailVerified ? (
                                        <FcCheckmark
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                right: '15px',
                                                transform: 'translateY(-50%)'
                                            }}
                                        />
                                    ) : (
                                        <button className='emailphoneverify-button'
                                            style={{
                                                top: '56%',
                                                right: '17px',
                                            }}
                                            onClick={handleSubmitEmail}
                                        >
                                            Verify
                                        </button>
                                    )}
                                </div>

                            </div>
                            <div className="d-flex">
                                <div style={{ position: 'relative', minHeight: '60px' }}>
                                    <label htmlFor="MobileNumber" className="loginlabel formInputs">Mobile Phone
                                        <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                                    </label>
                                    <PhoneInput
                                        international
                                        countryCallingCodeEditable={false}
                                        name="MobileNumber"
                                        maxLength={15}
                                        countries={['US']}
                                        value={formData.MobileNumber}
                                        id="MobileNumber"
                                        placeholder="Enter Your Contact Number"
                                        defaultCountry="US"
                                        onChange={(value) => handleInputChange({ target: { name: 'MobileNumber', value } })}
                                        className="Phone-Internal-Input"
                                        style={{ paddingRight: '80px', width: '250px' }}
                                    />
                                    {errors.MobileNumber && <div className="validation-error-owner">{errors.MobileNumber}</div>}

                                    {isphoneVerified ? (
                                        <FcCheckmark
                                            style={{
                                                position: 'absolute',
                                                top: '68%',
                                                right: '15px',
                                                transform: 'translateY(-50%)'
                                            }}
                                        />
                                    ) : (
                                        <button className='emailphoneverify-button'
                                            style={{
                                                top: '70%',
                                                right: '10px',
                                            }}
                                            onClick={handleSubmitPhone}
                                        >
                                            Verify
                                        </button>
                                    )}
                                </div>

                                <div>
                                    <label htmlFor="OfficeNumber" className="loginlabel formInputs">Office Phone</label>
                                    <PhoneInput
                                        international
                                        countryCallingCodeEditable={false}
                                        name="OfficeNumber"
                                        maxLength={15}
                                        countries={['US']}
                                        value={formData.OfficeNumber}
                                        id="OfficeNumber"
                                        placeholder="Enter Office Contact Number"
                                        defaultCountry="US"
                                        onChange={(value) => handleInputChange({ target: { name: 'OfficeNumber', value } })}
                                        className="Phone-Internal-Input"
                                    />
                                    {errors.OfficeNumber && <div className="validation-error-owner">{errors.OfficeNumber}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="section">
                            <h5>Entity Information</h5>
                            <div className="d-flex">
                                <InputField label="Entity Name" name="EntityName" value={formData.EntityName} onChange={handleInputChange} error={errors.EntityName} required />
                                <div className="input-address" ref={wrapperRef}>
                                    <InputField
                                        label="Entity Mailing Address"
                                        name="EnityMailingAdderess"
                                        value={formData?.EnityMailingAdderess}
                                        onChange={handleSearchChange}
                                        onFocus={() => setShowSuggestions(suggestions.length > 0)}
                                        error={errors.EnityMailingAdderess}
                                        required
                                        autoComplete="new-password"  // Prevent autofill and suggestions
                                    />
                                    {showSuggestions && suggestions.length > 0 && (
                                        <ul className="search-results-owner">
                                            {suggestions.map((result, index) => (
                                                <li key={index} onClick={() => handleAddressSelect(result)}>
                                                    {result.freeformAddress}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>

                                <InputField label="Mailing Address 2" name="EnityMailingAdderess2" value={formData.EnityMailingAdderess2} onChange={handleInputChange} />
                            </div>
                            <div className="d-flex gap-3 align-items-center form-group-owner">
                                <div className="form-group flex-grow-1">
                                    <label className='loginlabel'>ZIP Code <span className="mandatorymark">*</span></label>
                                    <input
                                        id="Zipcode"
                                        label="ZIP Code"
                                        name="Zipcode"
                                        type="number"
                                        value={formData.Zipcode}
                                        onChange={handleInputChange}
                                        error={errors.Zipcode}
                                        required
                                        // readOnly={true}
                                        disabled={true}
                                        className="form-control "
                                        style={{ cursor: "not-allowed" }} // optional for visual cue
                                    />
                                </div>
                                <div className="form-group flex-grow-1">
                                    <label className="loginlabel">City <span className="mandatorymark">*</span></label>
                                    <select
                                        name="CityId"
                                        value={formData.CityId ? String(formData.CityId) : ""}
                                        onChange={handleInputChange}
                                        className="form-control"
                                        // disabled={Boolean(formData.StateId && disabledStateCity)}
                                        disabled={true}
                                        style={{ cursor: "not-allowed" }}
                                        required
                                    >
                                        <option value="">Select City </option>
                                        {extendedCities.map((city) => (
                                            <option key={city.id} value={String(city.name)}>
                                                {city.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.CityId && <span className="validation-error-owner1">{errors.CityId}</span>}
                                </div>

                                <div className="form-group flex-grow-1">
                                    <label className="loginlabel">State <span className="mandatorymark">*</span></label>
                                    <select
                                        name="StateId"
                                        value={
                                            states.find(
                                                ({ iso2, name }) =>
                                                    iso2?.toLowerCase() === formData.StateId?.toLowerCase() ||
                                                    name?.toLowerCase() === formData.StateId?.toLowerCase()
                                            )?.iso2 || formData.StateId || ""
                                        }
                                        onChange={handleInputChange}
                                        className="form-control"
                                        required
                                        disabled={true}
                                        style={{ cursor: "not-allowed" }}
                                    >
                                        <option value="">Select State</option>
                                        {states.map(({ id, name, iso2 }) => {
                                            const value = iso2 || name;
                                            return (
                                                <option key={id} value={value}>
                                                    {name}
                                                </option>
                                            );
                                        })}
                                    </select>


                                    {errors.StateId && <span className="validation-error-owner1">{errors.StateId}</span>}
                                </div>


                            </div>

                            <div className="d-flex flex-nowrap justify-content-start align-items-start" style={{ overflowX: 'auto', width: '100%' }}>
                                <div className="me-4" style={{ minWidth: '260px' }}>
                                    <InputField
                                        label="Country"
                                        name="Country"
                                        type="text"
                                        value={formData.Country}
                                        required
                                        className="country"
                                        disabled={true}
                                    />
                                </div>

                                {/* Terms of Use */}
                                <div className="d-flex flex-column me-4" style={{ minWidth: '250px' }}>
                                    <div className="remembercheckbox">
                                        <label className="control control--checkbox mb-1">
                                            <input
                                                type="checkbox"
                                                checked={formData.TandC1}
                                                onChange={handleCheckboxChange1}
                                                disabled={!isemailVerified || !isphoneVerified || reitId}
                                            />
                                            <span className="ms-1">
                                                I Agree to
                                                <a className="joingeo ms-1" onClick={handleClickOpen("termsOfUses")}>
                                                    Terms of Use
                                                </a>
                                            </span>
                                            <div className="control__indicator"></div>
                                        </label>
                                        {errors.TandC1 && (
                                            <div className="error-message mandatorymark">{errors.TandC1}</div>
                                        )}
                                        {formData.TandC1 && (
                                            <>
                                                <label className="checked-by-label">
                                                    Checked by: {formData.FirstName} {formData.LastName}
                                                </label>                                                <label>
                                                    Date: {
                                                        formData.TandC1CreatedDate
                                                            ? new Date(formData.TandC1CreatedDate).toLocaleDateString('en-US')
                                                            : todayDate instanceof Date
                                                                ? `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                                : todayDate
                                                    }
                                                </label>
                                            </>
                                        )}
                                        {
                                            props.ownerb2cId && formData.TandC1 && (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                                    <div
                                                        className='uploaded-video-link'
                                                        onClick={() => {
                                                            setSelectedOwnerForVideo(formData);
                                                            setVideoModalOpen(true);
                                                        }}
                                                        style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}
                                                    >
                                                        {formData?.UploadRecordedVideoURL && formData?.UploadedVideoFileName ? "Replace" : "Add Video Recording"}
                                                    </div>
                                                    {formData.UploadRecordedVideoURL && (
                                                        <div className="mb-1">
                                                            <span
                                                                className="text-decoration-underline text-dark"
                                                                style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                                                onClick={() => {
                                                                    window.open(formData.UploadRecordedVideoURL, '_blank', 'noopener,noreferrer');
                                                                }}
                                                            >
                                                                {formData.UploadedVideoFileName
                                                                    ? `${formData.UploadedVideoFileName.slice(0, 6)}...${formData.UploadedVideoFileName.slice(-4)}`
                                                                    : "View Uploaded Video"}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                                {/* Terms of Service */}
                                <div className="d-flex flex-column me-4" style={{ minWidth: '250px' }}>
                                    <div className="remembercheckbox">
                                        <label className="control control--checkbox mb-1">
                                            <input
                                                type="checkbox"
                                                checked={formData.TandC2}
                                                onChange={handleCheckboxChange}
                                                disabled={!isemailVerified || !isphoneVerified || reitId}
                                            />
                                            <span className="ms-1">
                                                I Agree to
                                                <a className="joingeo ms-1" onClick={handleClickOpen("termsOfServices")}>
                                                    Terms of Service
                                                </a>
                                            </span>
                                            <div className="control__indicator"></div>
                                        </label>
                                        {errors.TandC2 && (
                                            <div className="error-message mandatorymark">{errors.TandC2}</div>
                                        )}
                                        {formData.TandC2 && (
                                            <>
                                                <label className="checked-by-label">
                                                    Checked by: {formData.FirstName} {formData.LastName}
                                                </label>
                                                <label>
                                                    Date: {
                                                        formData.TandC2CreatedDate
                                                            ? new Date(formData.TandC2CreatedDate).toLocaleDateString('en-US')
                                                            : todayDate instanceof Date
                                                                ? `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                                : todayDate
                                                    }
                                                </label>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Upload Section */}
                                <div className="d-flex flex-column" style={{ minWidth: '300px' }}>

                                    <div className="remembercheckbox3">
                                        <div className="mb-1 text-center w-100"><b>REIT</b></div>
                                        <label className="control control--checkbox mb-1 reit-checkbox-label">
                                            <input
                                                type="checkbox"
                                                checked={formData?.IsReitOwner}
                                                onChange={handleCheckboxChange3}
                                                disabled={!isemailVerified || !isphoneVerified || reitId}
                                            />
                                            <span className="ms-1">
                                                I Agree to
                                                <a className="joingeo ms-1" onClick={handleClickOpen("termsOfServices")}>
                                                    Terms of Service
                                                </a>
                                            </span>
                                            <div className="control__indicator"></div>
                                        </label>
                                        {errors.IsReitOwner && (
                                            <div className="error-message mandatorymark">{errors.IsReitOwner}</div>
                                        )}
                                        {formData.IsReitOwner && (<>
                                            <label className="checked-by-label">
                                                Checked by: {formData.FirstName} {formData.LastName}
                                            </label>

                                            <div className="mb-1">
                                                <label>Date: </label>
                                                <span>
                                                    {formData.IsReitOwnerCreatedDate
                                                        ? new Date(formData.IsReitOwnerCreatedDate).toLocaleDateString('en-US')
                                                        : todayDate instanceof Date
                                                            ? `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                            : todayDate}
                                                </span>
                                            </div>

                                            <div className="mb-1">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm me-2"
                                                    onClick={triggerFileUpload}
                                                >
                                                    📄 Upload <span className="mandatorymark">*</span>
                                                </button>

                                                {formData.AgreementFileName && (
                                                    <span
                                                        className="text-decoration-underline text-dark"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            if (formData.AgreementFileURL) {
                                                                window.open(formData.AgreementFileURL, '_blank', 'noopener,noreferrer');
                                                            }
                                                        }}
                                                    >
                                                        {formData.AgreementFileName}
                                                    </span>
                                                )}


                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    accept="application/pdf"

                                                    onChange={handleFileUpload}
                                                />

                                            </div>
                                            {errors.pdfUpload && (
                                                <div className="error-message mandatorymark">{errors.pdfUpload}</div>
                                            )}

                                            <div className='checked-by-label'>
                                                Uploaded by: {empDetails.firstName} {empDetails.lastName}
                                            </div></>)}
                                    </div>



                                </div>

                            </div>
                            {/* {pdfUrl && (
                                <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                                    View Uploaded PDF
                                </a>
                            )} */}



                        </div>
                        <BootstrapDialog
                            open={open}
                            onClose={handleClose}
                            title={`${dialogData.title}`}
                            content={dialogData.sections}
                            lastModified={`${dialogData.lastModified}`}
                            setOpen={setOpen}
                        />
                        {
                            < BootstrapDialogpopup
                                EmailPopUp={EmailPopUp}
                                open={openpopup}
                                initialEmail={EmailPopUp ? formData.EmailId : formData.MobileNumber}
                                destinationType={EmailPopUp ? "Email" : "MobileNumber"}
                                onVerify={handleVerify}
                                onResend={handleResend}
                                onClose={onClose}
                                InValidOTP={InValidOTP}
                                OTPValidation={OTPValidation}
                                sendOTPByEmail={sendOTPByEmail}
                                sendOTPByPhone={sendOTPByPhone} />
                        }

                        <div className="button-group">
                            <button type="button" className="cancel-button" onClick={handleCancel}>Cancel</button>
                            <button
                                type="button"
                                className={`submit-button ${(!isphoneVerified && !isemailVerified) || (props.ownerb2cId) ? 'enabled' : 'disabled'}`}
                                title={!(isphoneVerified && isemailVerified) ? 'Email and phone verification needs to be done' : ''}
                                onClick={() => { handleRegistrationSave() }}
                            >
                                Save
                            </button>
                            {!props.ownerb2cId &&
                                <button
                                    type="button"
                                    className={`submit-button ${((formData.TandC2 && formData.TandC1 && !formData.IsReitOwner) || (formData.IsReitOwner && formData.AgreementFileName)) && !formData.IsTempPassword ? 'enabled' : 'disabled'}`}
                                    title={!(isphoneVerified && isemailVerified) ? 'Email and phone verification needs to be done' : ''}
                                    onClick={() => { handleRegistration() }}
                                >
                                    Register
                                </button>
                            }

                        </div>
                    </form>
                </div >

            )}

            <UploadOwnerRecording
                open={videoModalOpen}
                onClose={handleCloseVideoModal}
                onSave={handleSaveVideo}
                showReplace={!!(formData?.UploadRecordedVideoURL && formData?.UploadedVideoFileName)}
                existingFile={{
                    name: formData?.UploadedVideoFileName,
                    size: uploadedVideoFileSize
                }}
                loader={loader}
            />
        </div >
    );
};

// Reusable Input Field Component
const InputField = ({ label, name, value, onChange, error, type = "text", required, autoComplete, readOnly }) => (
    <div className={`form-field mb-4 ${name}`}>
        <label htmlFor={name} className="loginlabel">
            {label} {required && <span className="mandatorymark">*</span>}
        </label>
        <input type={type} name={name} id={name} value={value} onChange={onChange} placeholder={`Enter ${label}`} autoComplete={autoComplete} readOnly={readOnly} />
        {error && <div className="validation-error-owner">{error}</div>}
    </div>
);

export default OwnerRegistration;
